module.exports = __webpack_public_path__ + "img/f4700e3.jpg";